import React, { useState, useEffect, useRef, useMemo } from "react";
import { Resizable } from "re-resizable";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import { useStoreState, useStoreActions } from "easy-peasy";
import styles from "./styles.module.css";

const ResizeHandle = () => {
  return <span className="react-resizable-handle react-resizable-handle-se"></span>;
};

export default function ElementDragResize(props) {
  const [showTooltip, setShowTooltip] = useState(false);
  const target = useRef(null);

  const [width, setWidth] = useState(props.width);
  const [height, setHeight] = useState(props.height);
  
  const updElementsOnPdfSize = useStoreActions((actions) => actions.updElementsOnPdfSize);

  const formElementsPDF = useStoreState((state) => state.formElementsPDF);
  const [element, setElement] = useState(() => {
    let el = formElementsPDF.filter((item) => {
      return item.i === props.id;
    });
    return el[0];
  });
  
  const [elementLabel, setElementLabel] = useState("");
  const [tooltipLabel, setTooltipLabel] = useState("");

  const lockAspectRatio = useMemo(() => {
    if (
      element && (
        element.fieldType === "checkbox" ||
        element.fieldType === "radioButton" ||
        element.fieldType === "radioButtonReverse"
      )
  ) {
    return true;
    }
    return false;
  }, [element]);

  useEffect(() => {
    setElement(() => {
      let el = formElementsPDF.filter((item) => {
        return item.i === props.id;
      });
      return el[0];
    });
    setElementLabel(() => {
      let el = formElementsPDF.filter((item) => {
        return item.i === props.id;
      })[0];
      let subEl = element.pdfData.filter((item) => {
        return item.sub_id === props.sub_id;
      })[0];
      if (el.fieldType == "checkbox") {
        return "Y/N";
      } else if (el.fieldType == "radioButton" || el.fieldType == "radioButtonReverse") {
        // Set label as "Yes" or "No" depending on item
        return `${subEl.label}`;
      } else {
        return el.formElementData.content;
      }
    });
    setTooltipLabel(() => {
      let subEl = element.pdfData.filter((item) => {
        return item.sub_id === props.sub_id;
      })[0];
      // console.log({ element });
      // console.log({ subEl });
      if (element.fieldType === "radioButton" || element.fieldType == "radioButtonReverse") {
        return `${element.formElementData.content}: ${subEl.label}`;
      }
      if (element.fieldType == "checkbox") {
        return `${subEl.label}: ${element.formElementData.content}`;
      }
      return subEl.label;
    });
  }, [formElementsPDF]);

  const handleResizeStart = (e, direction) => {
    if (direction === "bottomRight") {
      // console.log(direction);
      e.stopPropagation();
    }
  };
  const handleResizeStop = (e, direction, refToElement, delta) => {
    let newWidth = width + delta.width;
    let newHeight = height + delta.height;
    setWidth(newWidth);
    setHeight(newHeight);
    let data = { w: newWidth, h: newHeight, id: props.id, sub_id: props.sub_id };
    console.log({ data });
    updElementsOnPdfSize(data);
  };

  return (
    <Resizable
      defaultSize={{
        width: width,
        height: height,
      }}
      enable={{
        top: false,
        right: false,
        bottom: false,
        left: false,
        topRight: false,
        bottomRight: true,
        bottomLeft: false,
        topLeft: false,
      }}
      onResizeStart={handleResizeStart}
      onResizeStop={handleResizeStop}
      handleComponent={{
        bottomRight: props.flag ? <ResizeHandle /> : "",
      }}
      lockAspectRatio={lockAspectRatio}
    >
      <div
        ref={target}
        onClick={() => setShowTooltip(!showTooltip)}
        onPointerOver={() => setShowTooltip(true)}
        onPointerLeave={() => setShowTooltip(false)}
        className="box row align-items-end m-0"
        style={{ width: width + "px", height: height + "px" }}
      >
        <div className={`m-0 p-0 ${styles.fieldWrapper}`} dangerouslySetInnerHTML={{ __html: elementLabel }}>
          {/* w: {width} h: {height} */}
          {/* {element.formElementData.content} */}
        </div>
        <Overlay target={target.current} show={showTooltip} placement="top">
          {(props) => (
            <Tooltip id="overlay-example" {...props}>
              <div dangerouslySetInnerHTML={{ __html: tooltipLabel }}></div>
            </Tooltip>
          )}
        </Overlay>
      </div>
    </Resizable>
  );
}
